/* Required to get around ES6 hoisting */
/* https://stackoverflow.com/a/39820703/12148844 */

import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;
